import {
  sideBarKeys,
  useSideBarData,
} from '@/pages/tad.ai/_layout/SideBar/data'

export function useInWhichPage() {
  const router = useRouter()
  const href = useSideBarData()
  const hrefMap = new Map()
  href.forEach((item) => {
    hrefMap.set(item.key, item.href)
  })
  const inCreatePage = router.pathname.includes(hrefMap.get(sideBarKeys.create))
  const inLibraryPage = router.pathname.includes(
    hrefMap.get(sideBarKeys.library),
  )
  const inHomePage = router.pathname.includes(hrefMap.get(sideBarKeys.home))
  const inDetailPage = /\/l\/.+$/.test(router.pathname)
  const inHomepageDetail = /\/homepage\/detail/.test(router.pathname)
  const inAiCoverPage = router.pathname.includes(
    hrefMap.get(sideBarKeys.aiCover),
  )
  const inAiRapPage = router.pathname.includes(hrefMap.get(sideBarKeys.aiRap))
  const inTtsPage = router.pathname.includes(hrefMap.get(sideBarKeys.tts))
  const shouldShowMusicTagLabel =
    inLibraryPage || inCreatePage || inAiRapPage || inAiCoverPage || inTtsPage

  return {
    inCreatePage,
    inLibraryPage,
    inHomePage,
    inDetailPage,
    inHomepageDetail,
    inAiCoverPage,
    inAiRapPage,
    inTtsPage,
    shouldShowMusicTagLabel,
  }
}
